import { createContext, useEffect, useRef, useState } from "react";
import { Route, Routes } from "react-router";
import SignIn from "../auth/SignIn";
import FederalTaxes from "../user-details/FederalTaxes";
import HomeAddress from "../user-details/HomeAddress";
import PaymentMethod from "../user-details/PaymentMethod";
import PersonalInfo from "../user-details/PersonalInfo";
import StateTaxes from "../user-details/StateTaxes";
import ReviewInfo from "../user-details/ReviewInfo";
import { PAGE_TITLES } from "../constants/user-info.const";
import UserLayout from "../core/UserLayout";
import ExpiredLinkError from "../core/error-boundary/ExpiredLinkError";
import { RequireAuth } from "./RequireAuth";
import { getConfig } from "../../services/authService";
import { setConfig } from "../../store/actions/config";
import store from "../../store";
import ESign from "../user-details/ESign";
import TermsOfService from "../user-details/TermsOfService";
import {
    getEmployee,
    getOnboardingSteps,
} from "../../services/employeeService";
import { onboardingActions } from "../../store/actions/steps";
import InfoSubmitted from "../user-details/InfoSubmitted";
import { connect } from "react-redux";
import { SET_EMPLOYEE_DETAILS } from "../../store/actions/employee";
import { AppProvider } from "../../provider/AppProvider";
import ADPRoutes from "./ADPRoutes";
import { getUserType } from "../../utils/login";

export const AppContext = createContext<any>({});
function Routing(props) {
    const formRef: any = useRef();
    const { hideNextBtn } = props;
    const [viewName, setViewName] = useState("");
    const isLoggedIn = localStorage.getItem("isUserLoggedIn") === "true";
    const isAdpUser = getUserType();

    useEffect(() => {
        if (!isLoggedIn) return;
        !isAdpUser &&
            getConfig().then((response: any) => {
                store.dispatch(setConfig(response.data));
            });
    }, []);

    useEffect(() => {
        if (!isLoggedIn) return;
        !isAdpUser &&
            getOnboardingSteps().then((res: any) => {
                store.dispatch({
                    type: onboardingActions.SET_ONBOARDING_STEPS,
                    state: res?.data?.onboarding_steps_status,
                });
            });
    }, []);
    useEffect(() => {
        !isAdpUser &&
            isLoggedIn &&
            getEmployee().then((response: any) => {
                store.dispatch({
                    type: SET_EMPLOYEE_DETAILS,
                    state: response?.data,
                });
            });
    }, [isLoggedIn]);
    const handleSubmit = () => {
        formRef?.current.handleSubmit();
    };
    if (getUserType()) {
        return (
            <AppProvider>
                <ADPRoutes />
            </AppProvider>
        );
    }
    return (
        <AppContext.Provider value={{ viewName, setViewName }}>
            <Routes>
                <Route
                    path="/personal-info"
                    element={
                        <RequireAuth>
                            <UserLayout
                                title={PAGE_TITLES.personalInfo}
                                hidePrevSection={true}
                                handleSubmit={handleSubmit}
                                formRef={formRef}
                                hideNext={hideNextBtn}
                            >
                                <PersonalInfo formRef={formRef} />
                            </UserLayout>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/home-address"
                    element={
                        <RequireAuth>
                            <UserLayout
                                title={PAGE_TITLES.homeAddress}
                                handleSubmit={handleSubmit}
                                formRef={formRef}
                                hideNext={hideNextBtn}
                            >
                                <HomeAddress formRef={formRef} />
                            </UserLayout>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/federal-taxes"
                    element={
                        <RequireAuth>
                            <UserLayout
                                title={PAGE_TITLES.federalTaxes}
                                handleSubmit={handleSubmit}
                                formRef={formRef}
                                hideNext={hideNextBtn}
                            >
                                <FederalTaxes formRef={formRef} />
                            </UserLayout>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/state-taxes"
                    element={
                        <RequireAuth>
                            <UserLayout
                                title={PAGE_TITLES.stateTaxes}
                                formRef={formRef}
                                handleSubmit={handleSubmit}
                                hideNext={hideNextBtn}
                            >
                                <StateTaxes formRef={formRef} />
                            </UserLayout>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/payment-method"
                    element={
                        <RequireAuth>
                            <UserLayout
                                title={PAGE_TITLES.paymentMethod}
                                handleSubmit={handleSubmit}
                                formRef={formRef}
                                hideNext={hideNextBtn}
                            >
                                <PaymentMethod formRef={formRef} />
                            </UserLayout>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/review-info"
                    element={
                        <RequireAuth>
                            <UserLayout
                                title={PAGE_TITLES.reviewInfo}
                                handleSubmit={handleSubmit}
                                formRef={formRef}
                                hideNext={hideNextBtn}
                            >
                                <ReviewInfo formRef={formRef} />
                            </UserLayout>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/e-sign"
                    element={
                        <RequireAuth>
                            <UserLayout
                                title={PAGE_TITLES.eSign}
                                hideNext={true}
                                formRef={formRef}
                            >
                                <ESign />
                            </UserLayout>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/terms-of-service"
                    element={
                        <RequireAuth>
                            <UserLayout
                                title={PAGE_TITLES.termsOfService}
                                handleSubmit={handleSubmit}
                                formRef={formRef}
                                hideNext={hideNextBtn}
                            >
                                <TermsOfService formRef={formRef} />
                            </UserLayout>
                        </RequireAuth>
                    }
                />
                <Route path="/info-submitted" element={<InfoSubmitted />} />
                <Route path="/expired-link" element={<ExpiredLinkError />} />
                <Route
                    path="/"
                    element={
                        <AppProvider>
                            <SignIn />
                        </AppProvider>
                    }
                />
                <Route
                    path="*"
                    element={
                        <AppProvider>
                            <SignIn />
                        </AppProvider>
                    }
                />
            </Routes>
        </AppContext.Provider>
    );
}
const mapStateToProps = (state) => ({
    hideNextBtn: state.nextBtn.isShowNext,
});

export default connect(mapStateToProps)(Routing);
